export default "__VITE_ASSET__CuB9n6fT__"